import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind classes win over earlier ones.
 *
 * Plain string concatenation breaks the moment a caller wants to override a
 * component's default — `"px-3" + " px-6"` leaves both in the class list and
 * the winner depends on stylesheet order. twMerge resolves the conflict by
 * Tailwind's own semantics instead.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
